
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/shadows.st.css.js";
import "../Foundation/stylable/default-scroll-bar.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_187_1_ModalMobileLayout";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_187_1_ModalMobileLayout__root","defaultScrollBar":"wds_1_187_1_defaultscrollbar__defaultScrollBar","container":"wds_1_187_1_ModalMobileLayout__container","close":"wds_1_187_1_ModalMobileLayout__close","content":"wds_1_187_1_ModalMobileLayout__content"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {}; 




